  export default {
	"当前语言": "En",

	"公共.没有更多数据了": "No more data",
	"公共.加载中": "Loading",
	"公共.下拉刷新": "Pull to refresh",
	"公共.释放刷新": "Release to refresh",
	"公共.链接钱包": "Connect Wallet",

	"菜单.首页": "Home",
	"菜单.节点": "Node",
	"菜单.生态": "Ecosystem",
	"菜单.团队": "Team",
	"菜单.个人": "Profile",

	"首页.轮播.标题": "Make real-world assets flow on-chain with trust, security, and instantaneity",
	"首页.轮播.描述1": "Towards real-world assets",
	"首页.轮播.描述2": "AI-driven performance public chain",
	"首页.以太坊": "Ethereum",
	"首页.企业绩效管理": "Enterprise Performance Management",
	"首页.仲裁委员会": "Arbitration Committee",
	"首页.探索DApps": "Explore DApps",
	"首页.发现去中心化应用程序": "Discover decentralized applications",
	"首页.查看所有Dapps": "View all Dapps",
	"首页.战略合作伙伴": "Strategic Partners",
	"首页.值得信赖的生态系统合作伙伴": "Trusted ecosystem partners",
	"首页.全部": "All",
	"首页.去中心化金融": "DeFi",
	"首页.非同质化代币": "NFT",
	"首页.最新消息": "Latest News",
	"首页.保持对Web3关注": "Stay focused on Web3",
	"首页.官方频道": "Official Channel",

	"首页.官方频道.推特.名称": "Twitter",
	"首页.官方频道.推特.描述": "@web3 platform",
	"首页.官方频道.Discord.名称": "Discord",
	"首页.官方频道.Discord.描述": "@web3 platform",
	"首页.官方频道.电报.名称": "Telegram",
	"首页.官方频道.电报.描述": "Official updates",
	"首页.官方频道.GitHub.名称": "GitHub",
	"首页.官方频道.GitHub.描述": "Open source",
    "首页.官方频道.RoonChain.官网": "RoonChain",
    "首页.官方频道.RoonChain.描述": "WebSite",

	"首页.标签.Defi": "DeFi",
	"首页.标签.数据分析": "Data Analytics",
	"首页.标签.链游": "Blockchain Games",
	"首页.标签.其他": "Others",
	"首页.标签.DEX": "DEX",

	"首页.合作伙伴.Solana.描述": "Solana is a blockchain built for mass adoption. Fast, composable, green, globally decentralized.",
	"首页.合作伙伴.CoinStats.描述": "One-stop token portfolio tracker; manage portfolios easily and efficiently.",
	"首页.合作伙伴.Shaga.描述": "Shaga aims to deliver a revolutionary gaming experience.",
	"首页.合作伙伴.Grass.描述": "Share unused internet bandwidth with Grass to earn rewards.",
	"首页.合作伙伴.Jupiter.描述": "Building the best exchange in crypto and becoming a DeFi giant.",
	"首页.合作伙伴.boop.fun.描述": "Build a Meme coin community, stake BOOP, unlock airdrop rewards.",

	"闪兑.闪兑中心": "RGT Exchange",
	"闪兑.闪兑": "Swap",
	"闪兑.即时互换": "Instant Exchange",
	"闪兑.快速兑换 · 实时到账 · 20:1比例": "Fast exchange · Real-time arrival · 20:1 ratio",
	"闪兑.极速闪兑": "Lightning Swap",
	"闪兑.安全可靠": "Safe and Reliable",
	"闪兑.RGT余额": "RGT Balance",
	"闪兑.ROON余额": "ROON Balance",
	"闪兑.可用于闪兑": "Available for swap",
	"闪兑.闪兑获得": "Swap to get",
	"闪兑.节点等级": "Node Level",
	"闪兑.闪兑比例": "Swap Ratio",
	"闪兑.闪兑优惠": "Swap Discount",
	"闪兑.手续费": "Fee",
	"闪兑.闪兑数量": "Swap Amount",
	"闪兑.输入RGT数量": "Enter RGT amount",
	"闪兑.最低": "Minimum",
	"闪兑.余额": "Balance",
	"闪兑.将获得": "Will get",
	"闪兑.立即闪兑": "Swap Now",
	"闪兑.闪兑说明": "Swap Instructions",
	"闪兑.极速到账": "Lightning arrival",
	"闪兑.闪兑后ROON立即到账，无需等待": "ROON arrives immediately after swap, no waiting",
	"闪兑.安全保障": "Security Guarantee",
	"闪兑.零手续费": "Zero Fee",
	"闪兑.享受零手续费特权": "Enjoy zero fee privilege",
	"闪兑.闪兑成功": "Swap Successful",
	"闪兑.ROON已成功转入您的钱包": "ROON has been successfully transferred to your wallet",
	"闪兑.消耗RGT": "RGT Consumed",
	"闪兑.获得ROON": "ROON Received",
	"闪兑.确认": "Confirm",
	"闪兑.将提取到钱包": "Transfer to Wallet",

	"ROONMining.LP池": "LP Pool",
	"ROONMining.我的流动性": "My Liquidity",
	"ROONMining.我的LP数据": "My LP Data",
	"ROONMining.累计收益": "Cumulative Earnings",
	"ROONMining.剩余天数": "Remaining Days",
	"ROONMining.天": "Days",
	"ROONMining.推荐收益": "Referral Earnings",
	"ROONMining.总本金": "Total Principal",
	"ROONMining.添加LP": "Add LP",
	"ROONMining.我的LP": "My LP",
	"ROONMining.查看详情": "View Details",
	"ROONMining.明细": "Details",
	"ROONMining.提现": "Withdraw",
	"ROONMining.更多功能": "More Features",
	"ROONMining.推荐系统": "Referral System",
	"ROONMining.直推10%收益": "Direct Referral 10% Earnings",
	"ROONMining.分红池": "Dividend Pool",
	"ROONMining.多重收益分配": "Multiple Revenue Distribution",
	"ROONMining.NFT权益": "NFT Rights",
	"ROONMining.节点与矿机": "Nodes & Mining Machines",
	"ROONMining.挖矿规则": "Mining Rules",
	"ROONMining.20天为一个周期,中间不可撤出LP": "20-day cycle, LP cannot be withdrawn mid-cycle",
	"ROONMining.LP每个钱包地址最多添加一次LP": "Each wallet address can add LP maximum once",
	"ROONMining.每个LP每天收益1个ROON": "Each LP earns 1 ROON per day",
	"ROONMining.20天到期:本金+20个ROON": "20-day maturity: principal + 20 ROON",
	"ROONMining.保障本金+利息,不受价格波动影响": "Guarantees principal + interest, unaffected by price fluctuations",

	"添加流动性.添加流动性": "Add Liquidity",
	"添加流动性.重要提示": "Important Notice",
	"添加流动性.每个钱包地址仅可添加一次LP，20天锁定期内无法撤出，请谨慎操作": "Each wallet address can only add LP once; LP cannot be withdrawn during the 20-day lock period. Please proceed with caution.",
	"添加流动性.添加LP组合": "Add LP Pair",
	"添加流动性.数量": "Amount",
	"添加流动性.余额": "Balance",
	"添加流动性.请输入USDR数量": "Please enter USDR amount",
	"添加流动性.最大": "Max",
	"添加流动性.请输入ROON数量": "Please enter ROON amount",
	"添加流动性.LP组成比例为": "LP composition ratio is",
	"添加流动性.确认添加LP": "Confirm Add LP",
	"添加流动性.挖矿规则": "Mining Rules",
	"添加流动性.锁走周期20天，期间无法撤出": "20-day lock period; withdrawal is not allowed during this time",
	"添加流动性.每天固定收益1个ROON代币": "Fixed daily earnings of 1 ROON token",
	"添加流动性.保障本金安全，不受市场价格波动影响": "Principal is protected and not affected by market price fluctuations",
	"添加流动性.每个钱包地址仅可添加一次LP": "Each wallet address can only add LP once",
	"添加流动性.所有数据链上透明可查": "All data is transparent and verifiable on-chain",
	"添加流动性.您即将添加": "You are about to add",
	"添加流动性.到流动性池": "to the liquidity pool",
	"添加流动性.锁定期": "Lock Period",
	"添加流动性.天": "Days",
	"添加流动性.预计收益": "Estimated Earnings",

	"我的LP.我的LP": "我的LP",
	"我的LP.添加流动性": "Add Liquidity",
	"我的LP.进行中": "In Progress",
	"我的LP.已完成": "Completed",
	"我的LP.总价值": "Total Value",
	"我的LP.剩余": "Remaining",
	"我的LP.天": "Days",
	"我的LP.锁定中": "Locked",
	"我的LP.移除LP": "Remove LP",
  "我的LP.已移除": "Removed",
  "LP日志.日志明细": "Log Details",
  "LP日志.确定复投LP": "Confirm Reinvest LP",
  "LP日志.确定复投": "Confirm Reinvest",
	"我的LP.确认移除LP": "Confirm Remove LP",
	"我的LP.您即将移除LP并获得以下资产": "You are about to remove LP and receive the following assets",
	"我的LP.本金返还": "Principal Return",
	"我的LP.收益": "Earnings",
	"我的LP.总计": "Total",
	"我的LP.确认移除": "Confirm Removal",

	"持有LP数": "LPs held",
	"我的LP": "My LP",
	"暂无LP记录": "No LP records",

	"推荐系统.推荐系统": "Referral System",
	"推荐系统.我的团队": "My Team",
	"推荐系统.直推人数": "Direct Referrals",
	"推荐系统.团队总人数": "Total Team Size",
	"推荐系统.累计收益": "Cumulative Earnings",
	"推荐系统.待领取收益": "Pending Earnings",
	"推荐系统.领取收益": "Claim Earnings",
	"推荐系统.我的推荐链接": "My Referral Link",
	"推荐系统.复制连接": "Copy Link",
	"推荐系统.分享链接给好友，好友添加LP后您将获得其收益的10%作为推荐奖": "Share link with friends, earn 10% of their earnings as referral bonus when they add LP",
	"推荐系统.当前等级权益": "Current Level Benefits",
	"推荐系统.个直推": "Direct Referrals",
	"推荐系统.推荐奖励": "Referral Rewards",
	"推荐系统.当前等级": "Current Level",
	"推荐系统.领取成功": "Claim Successful",
	"推荐系统.已成功领取": "Successfully Claimed",
	"推荐系统.复制": "Copy",
	"推荐系统.收益已发送到您的钱包地址": "Earnings have been sent to your wallet address",
	"推荐系统.上级地址": "Parent Address",

	"分红池.分红池": "Dividend Pool",
	"分红池.持有者": "Holders",
	"分红池.锁仓": "Staking",
	"分红池.FOMO": "FOMO",
	"分红池.保险": "Insurance",

	"分红池.LP持有者分红": "LP Holder Dividend",
	"分红池.分红奖池总额": "Total Dividend Pool",
	"分红池.我的LP": "My LP",
	"分红池.持有者列表": "Holders List",
	"分红池.分红规则": "Dividend Rules",
	"分红池.盈利的25%自动分配给所有LP持有者": "25% of profits are automatically distributed to all LP holders",
	"分红池.按照LP持有比例进行分红": "Dividends are distributed based on LP holding ratio",
	"分红池.每周自动发放到钱包地址": "Automatically distributed to wallet address weekly",
	"分红池.下次分红时间": "Next Dividend Time",

	"分红池.锁仓记录": "Staking Records",
	"分红池.查看所有ROON锁仓记录": "View all ROON staking records",
	"分红池.开始日期": "Start Date",
	"分红池.锁定中": "Locked",
	"分红池.锁仓时长": "Staking Duration",
	"分红池.已锁定": "Locked",
	"分红池.天": "Days",
	"分红池.剩余时间": "Remaining Time",
	"分红池.已完成": "Completed",
	"分红池.锁仓已完成，可领取": "Staking completed, ready to claim",
	"分红池.锁仓说明": "Staking Instructions",
	"分红池.锁走期为1年，期间无法提取": "1-year lock period, no withdrawal allowed",
	"分红池.到期后获得本金+固定收益": "Receive principal + fixed returns upon maturity",
	"分红池.收益来自盈利分配池": "Earnings come from profit distribution pool",

	"分红池.FOMO池": "FOMO Pool",
	"分红池.奖池总额": "Total Prize Pool",
	"分红池.倒计时": "Countdown",
	"分红池.最后参与": "Last Participation",
	"分红池.排行榜（前20名）": "Leaderboard (Top 20)",
	"分红池.奖励分配规则": "Reward Distribution Rules",
	"分红池.排名": "Ranking",
	"分红池.奖励": "Reward",
	"分红池.第": "No.",
	"分红池.名": "Name",
	"分红池.平分": "Equal Share",
	"分红池.FOMO规则": "FOMO Rules",
	"分红池.48小时内无新增参与则触发分配": "Distribution triggered if no new participation within 48 hours",
	"分红池.保险池每10天转入10%到FOMO池": "Insurance pool transfers 10% to FOMO pool every 10 days",
	"分红池.前20名按排名获得奖励": "Top 20 receive rewards based on ranking",

	"分红池.保险池总额": "Total Insurance Pool",
	"分红池.待转入FOMO池": "Pending Transfer to FOMO Pool",
	"分红池.下次转入": "Next Transfer",
	"分红池.天后": "Days Later",
	"分红池.资金流向": "Fund Flow",
	"分红池.保险池": "Insurance Pool",
	"分红池.盈利的25%进入保险池": "25% of profits enter the insurance pool",
	"分红池.每10天转入保险池的10%": "Transfer 10% from insurance pool every 10 days",
	"分红池.保险池作用": "Insurance Pool Function",
	"分红池.保障系统稳定运行": "Ensure system stable operation",
	"分红池.定期为FOMO池注入资金": "Regularly inject funds into FOMO pool",
	"分红池.应对市场波动风险": "Handle market volatility risks",


	"NFT权益.NFT权益": "NFT Rights",
	"NFT权益.NFT权益系统": "NFT Rights System",
	"NFT权益.节点与矿机双重收益": "Dual earnings from nodes and mining machines",
	"NFT权益.我的NFT": "My NFTs",
	"NFT权益.NFT收益": "NFT Earnings",
	"NFT权益.节点NFT": "Node NFT",
	"NFT权益.矿机NFT": "Mining Machine NFT",

	"NFT权益.超级节点": "Super Node",
	"NFT权益.专属权益": "Exclusive Rights",
	"NFT权益.20%额外收益": "20% Additional Earnings",
	"NFT权益.优先提现权": "Priority Withdrawal Rights",
	"NFT权益.治理投票权": "Governance Voting Rights",
	"NFT权益.专属客服": "Dedicated Customer Service",
	"NFT权益.价格": "Price",
	"NFT权益.总量": "Total Supply",
	"NFT权益.剩余": "Remaining",
	"NFT权益.立即购买": "Buy Now",
	"NFT权益.已拥有": "Owned",

	"NFT权益.钻石矿机": "Diamond Mining Machine",
	"NFT权益.传说": "Legendary",
	"NFT权益.算力": "Hashrate",
	"NFT权益.日产出": "Daily Output",
	"NFT权益.史诗": "Epic",

	"NFT权益.累计收益": "Cumulative Earnings",
	"NFT权益.查看详情": "View Details",
	"NFT权益.NFT权益说明": "NFT Rights Description",
	"NFT权益.节点NFT提供额外收益加成和治理权": "Node NFT provides additional earnings bonus and governance rights",
	"NFT权益.矿机NFT提供持续的挖矿产出": "Mining machine NFT provides continuous mining output",
	"NFT权益.所有NFT权益永久有效": "All NFT rights are permanently valid",


	"ROON锁仓.ROON锁仓": "ROON Staking",
	"ROON锁仓.线性解锁": "Linear Unlock",
	"ROON锁仓.安全锁仓 · 线性解锁 · 随时提取": "Secure staking · Linear unlock · Withdraw anytime",
	"ROON锁仓.安全锁仓": "Secure Staking",
	"ROON锁仓.总锁仓全部": "Total Staked",
	"ROON锁仓.解锁进度": "Unlock Progress",
	"ROON锁仓.已解锁": "Unlocked",
	"ROON锁仓.解锁周期": "Unlock Period",
	"ROON锁仓.周期": "Period",
	"ROON锁仓.可提取金额": "Withdrawable Amount",
	"ROON锁仓.提取ROON": "Withdraw ROON",
	"ROON锁仓.输入提取数量": "Enter withdrawal amount",
	"ROON锁仓.最低": "Minimum",
	"ROON锁仓.可提取": "Withdrawable",
	"ROON锁仓.立即提取": "Withdraw Now",
	"ROON锁仓.锁仓说明": "Staking Instructions",
	"ROON锁仓.ROON已成功转入您的钱包": "ROON has been successfully transferred to your wallet",
	"ROON锁仓.闪兑获得的ROON将按照固定周期线性": "ROON obtained from swap will be linearly unlocked according to fixed periods",
	"ROON锁仓.随时提取": "Withdraw anytime",
	"ROON锁仓.安全保障": "Security Guarantee",
	"ROON锁仓.智能合约锁仓，资金安全有保障": "Smart contract staking, funds are secure",
	"ROON锁仓.提取成功": "Withdrawal Successful",
	"ROON锁仓.提取金额": "Withdrawal Amount",
	"ROON锁仓.确认": "Confirm",

	"USDR闪兑.USDR闪兑": "USDR Swap",
	"USDR闪兑.闪兑": "Swap",
	"USDR闪兑.余额": "Balance",
	"USDR闪兑.极速闪兑": "Lightning Swap",
	"USDR闪兑.快速兑换 · 安全可靠": "Fast exchange · Safe and reliable",
	"USDR闪兑.安全可靠": "Safe and reliable",
	"USDR闪兑.闪兑比例": "Swap ratio",
	"USDR闪兑.实时汇率": "Real-time exchange rate",
	"USDR闪兑.闪兑数量": "Swap amount",
	"USDR闪兑.输入USDR数量": "Enter USDR amount",
	"USDR闪兑.将获得": "Will get",
	"USDR闪兑.立即闪兑": "Swap now",
	"USDR闪兑.闪兑记录": "Swap records",
	"USDR闪兑.提现记录": "Withdrawal records",
	"USDR闪兑.兑换成功": "Exchange successful",
	"USDR闪兑.已完成": "Completed",
	"USDR闪兑.处理中": "Processing",
	"USDR闪兑.消耗": "Consumed",
	"USDR闪兑.获得": "Received",
	"USDR闪兑.提现": "Withdraw",
	"USDR闪兑.提现金额": "Withdrawal amount",
	"USDR闪兑.可用余额": "Available balance",
	"USDR闪兑.提现数量": "Withdrawal quantity",
	"USDR闪兑.充值数量": "Recharge quantity",
	"USDR闪兑.请输入数量": "Please enter amount",
	"USDR闪兑.提现地址": "Withdrawal address",
	"USDR闪兑.输入钱包地址": "Enter wallet address",
	"USDR闪兑.确认": "Confirm",

	"质押.质押中": "Staking",
	"质押.收益": "Earnings",
	"质押.ROON锁仓": "ROON Staking",
	"质押.天": "Days",
	"质押.年化收益率": "Annualized Return",
	"质押.最低": "Minimum",
	"质押.质押金额": "Staking Amount",
	"质押.输入质押金额": "Enter Staking Amount",
	"质押.最大": "Maximum",
	"质押.余额": "Balance",
	"质押.立即质押": "Stake Now",
	"质押.我的质押": "My Staking",
	"质押.查看全部质押": "View All Staking",
	"质押.进行中": "In Progress",
	"质押.天锁定": "Days Locked",
	"质押.年百分率": "Annual Percentage Rate",
	"质押.质押进度": "Staking Progress",
	"质押.剩余": "Remaining",
	"质押.累计收益": "Cumulative Earnings",
	"质押.详情": "Details",

	"销毁挖矿.销毁挖矿": "Burn Mining",
	"销毁挖矿.实时销毁数据": "Real-time Burn Data",
	"销毁挖矿.全网销毁": "Network-wide Burn",
	"销毁挖矿.我的销毁": "My Burn",
	"销毁挖矿.占比": "Proportion",
	"销毁挖矿.分享收益": "Share Earnings",
	"销毁挖矿.提现": "Withdraw",
	"销毁挖矿.明细": "Details",
	"销毁挖矿.已销毁": "Burned",
	"销毁挖矿.锁仓中": "Locked",
	"销毁挖矿.今日可领": "Claimable Today",
	"销毁挖矿.开始销毁": "Start Burning",
	"销毁挖矿.销毁记录": "Burn Records",
	"销毁挖矿.选择销毁档位": "Select Burn Tier",
	"销毁挖矿.个档位可选": "tiers available",
	"销毁挖矿.天": "Days",
	"销毁挖矿.确认销毁": "Confirm Burn",
	"销毁挖矿.销毁挖矿": "Burn Mining",
	"销毁挖矿.团队": "Team",
	"销毁挖矿.释放进度": "Release Progress",
	"销毁挖矿.总收益": "Total Earnings",
	"销毁挖矿.每日释放": "Daily Release",
	"销毁挖矿.已到账": "Received",
	"销毁挖矿.待释放": "Pending Release",
	"销毁挖矿.自动释放中": "Auto-releasing",

	"销毁我的团队.我的团队": "My Team",
	"销毁我的团队.邀请好友": "Invite Friends",
	"销毁我的团队.团队列表": "Team List",
	"销毁我的团队.直推人数": "Direct Referrals",
	"销毁我的团队.直推收益": "Direct Referral Earnings",
	"销毁我的团队.我的邀请码": "My Invitation Code",
	"销毁我的团队.复制": "Copy",
	"销毁我的团队.复制链接": "Copy Link",
	"销毁我的团队.分享链接": "Share Link",
	"销毁我的团队.邀请规则": "Invitation Rules",
	"销毁我的团队.直推好友销毁可获得5%奖励": "Earn 5% reward when direct referrals burn",
	"销毁我的团队.团队等级越高，极差收益越多": "Higher team level, more differential earnings",
	"销毁我的团队.NFT节点极差:1%-5%": "NFT Node Differential: 1%-5%",
	"销毁我的团队.矿机领航者极差:1%-5%": "Mining Machine Leader Differential: 1%-5%",
	"销毁我的团队.流动性挖矿极差:R1-R10(1%-10%)": "Liquidity Mining Differential: R1-R10(1%-10%)",
	"销毁我的团队.质押NFT解锁团队奖励": "Stake NFT to unlock team rewards",
	"销毁我的团队.质押NFT后可获得团队极差奖励(1%-5%)，享受更多收益": "After staking NFT, unlock team differential rewards (1%-5%) and enjoy more earnings",
	"销毁我的团队.立即质押NFT": "Stake NFT Now",
	"销毁我的团队.我的等级": "My Level",
	"销毁我的团队.极差": "Differential",
	"销毁我的团队.领航者": "Leader",
	"销毁我的团队.团队收益": "Team Earnings",
	"销毁我的团队.团队总人数": "Total Team Size",
	"销毁我的团队.团队销毁量": "Team Burn Volume",
	"销毁我的团队.直推成员": "Direct Members",
	"销毁我的团队.共": "Total",
	"销毁我的团队.人": "people",
	"销毁我的团队.等级说明": "Level Description",
	"销毁我的团队.R1-R10:流动性挖矿等级，极差1%-10%": "R1-R10: Liquidity Mining Level, Differential 1%-10%",
	"销毁我的团队.NFT节点:质押NFT获得，极差1%-5%": "NFT Node: Obtained by staking NFT, Differential 1%-5%",
	"销毁我的团队.矿机领航者:团队销毁达标，极差1%-5%": "Mining Machine Leader: Team burn meets standards, Differential 1%-5%",
	"销毁我的团队.等级越高，团队收益越多": "Higher level, more team earnings",
	"销毁我的团队.质押NFT": "Stake NFT",
	"销毁我的团队.质押NFT后将解锁团队极差奖励功能，享受1%-5%的团队收益分成": "After staking NFT, unlock team differential reward function and enjoy 1%-5% team revenue share",
	"销毁我的团队.NFT数量": "NFT Quantity",
	"销毁我的团队.个": "pieces",
	"销毁我的团队.质押周期": "Staking Period",
	"销毁我的团队.永久": "Permanent",
	"销毁我的团队.团队极差": "Team Differential",
	"销毁我的团队.确认质押": "Confirm Staking",


	"NUT.菜单.首页": "Home",
	"NUT.菜单.奖励": "Rewards",
	"NUT.菜单.介绍": "Introduction",
	"NUT.菜单.奖励池": "Reward Pool",

	"NUT.首页.活跃": "Active",
	"NUT.首页.下一代DeFi生态代币": "Next Generation DeFi Ecosystem Token",
	"NUT.首页.燃烧池": "Burn Pool",
	"NUT.首页.稳定池": "Stable Pool",
	"NUT.首页.托底池": "Support Pool",
	"NUT.首页.LP奖励": "LP Rewards",
	"NUT.首页.参与质押": "Participate in Staking",
	"NUT.首页.参与激励": "Participation Incentives",
	"NUT.首页.我的参与统计": "My Participation Statistics",
	"NUT.首页.总参与": "Total Participation",
	"NUT.首页.份数": "Shares",
	"NUT.首页.预计收益": "Estimated Earnings",
	"NUT.首页.参与数量": "Participation Quantity",
	"NUT.首页.余额": "Balance",
	"NUT.首页.最大": "Maximum",
	"NUT.首页.份": "Share",
	"NUT.首页.参与规则说明": "Participation Rules Description",
	"NUT.首页.1,000 ROON =1份，可多次参与": "1,000 ROON = 1 share, can participate multiple times",
	"NUT.首页.35%全网分红ROON": "35% Network-wide ROON Dividend",
	"NUT.首页.65%自动组LP锁定999年": "65% Auto LP Pair Locked for 999 years",
	"NUT.首页.全链上执行，透明可查": "Fully on-chain execution, transparent and verifiable",
	"NUT.首页.收益分配": "Earnings Distribution",
	"NUT.首页.全网分红": "Network-wide Dividend",
	"NUT.首页.组LP锁定": "LP Pair Lock",
	"NUT.首页.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "Out of 65 ROON: 32.5 buy NUT + 32.5 ROON for LP pair",
	"NUT.首页.最少": "Minimum",

	"NUT.奖励.我的奖励总览": "My Reward Overview",
	"NUT.奖励.可领取奖励": "Claimable Rewards",
	"NUT.奖励.已领取总额": "Total Claimed",
	"NUT.奖励.税收分红": "Tax Dividends",
	"NUT.奖励.持币分红": "Holding Dividends",
	"NUT.奖励.LP奖励": "LP Rewards",
	"NUT.奖励.NFT分红": "NFT Dividends",
	"NUT.奖励.税收分红领取": "Claim Tax Dividends",
	"NUT.奖励.盈利税+砸盘税": "Profit Tax + Dump Tax",
	"NUT.奖励.盈利税分红": "Profit Tax Dividends",
	"NUT.奖励.回购": "Buyback",
	"NUT.奖励.砸盘税分红": "Dump Tax Dividends",
	"NUT.奖励.总可领取": "Total Claimable",
	"NUT.奖励.领取时50%销毁，50%到账": "50% burned, 50% to account when claimed",
	"NUT.奖励.税收机制说明": "Tax Mechanism Description",
	"NUT.奖励.盈利税20%:回购ROON分红给参与者": "Profit Tax 20%: ROON buyback dividends to participants",
	"NUT.奖励.盘税25%:每日8点AVE价格为准，跌1%扣2%": "Dump Tax 25%: Based on 8 AM daily AVE price, drop 1% deduct 2%",
	"NUT.奖励.最高下跌12.5%时税率达25%": "Tax rate reaches 25% when dropping 12.5% maximum",
	"NUT.奖励.领取税收分红": "Claim Tax Dividends",

	"NUT.奖励.持币分红": "Holding Dividends",
	"NUT.奖励.手续费": "Transaction Fee",
	"NUT.奖励.可领取": "Claimable",
	"NUT.奖励.下次分红": "Next Dividend",
	"NUT.奖励.已领取": "Claimed",
	"NUT.奖励.参与条件": "Participation Conditions",
	"NUT.奖励.持有": "Hold",
	"NUT.奖励.领取费用": "Claim Fee",
	"NUT.奖励.价值": "Value",
	"NUT.奖励.领取时50%销毁，50%到账": "50% burned, 50% to account when claimed",
	"NUT.奖励.领取奖励": "Claim Rewards",

	"NUT.奖励.LP贡献奖励": "LP Contribution Rewards",
	"NUT.奖励.我的流动性": "My Liquidity",
	"NUT.奖励.池份额": "Pool Shares",
	"NUT.奖励.LP每小时自动撤出0.25%，0.125%燃烧，0.125%分红": "LP automatically withdraws 0.25% per hour, 0.125% burned, 0.125% dividends",
	"NUT.奖励.添加流动性": "Add Liquidity",
	"NUT.奖励.流动性池": "Liquidity Pool",
	"NUT.奖励.当前池子比例": "Current Pool Ratio",
	"NUT.奖励.数量": "Amount",
	"NUT.奖励.余额": "Balance",
	"NUT.奖励.请输入NUT数量": "Please enter NUT amount",
	"NUT.奖励.请输入ROON数量": "Please enter ROON amount",
	"NUT.奖励.最大": "Maximum",
	"NUT.奖励.花店容差": "Slippage Tolerance",
	"NUT.奖励.自定义": "Custom",
	"NUT.奖励.取消": "Cancel",
	"NUT.奖励.确认添加": "Confirm Add",

	"NUT.奖励.NFT资产分红": "NFT Asset Dividends",
	"NUT.奖励.盈利税": "Profit Tax",
	"NUT.奖励.节点NFT": "Node NFT",
	"NUT.奖励.白名单NFT": "Whitelist NFT",
	"NUT.奖励.持有": "Hold",
	"NUT.奖励.个": "pieces",
	"NUT.奖励.NFT分红规则": "NFT Dividend Rules",
	"NUT.奖励.节点NFT:50%分红(权重值分配)": "Node NFT: 50% dividends (weighted allocation)",
	"NUT.奖励.白名单NFT:50%分红(加权平均)": "Whitelist NFT: 50% dividends (weighted average)",
	"NUT.奖励.激活条件: 持币≥100.000 NUT": "Activation condition: Hold ≥100.000 NUT",
	"NUT.奖励.领取时50%销毁，50%到账": "50% burned, 50% to account when claimed",
	"NUT.奖励.领取全部NFT奖励": "Claim All NFT Rewards",

	"NUT.介绍.NUT 代币": "NUT Token",
	"NUT.介绍.创新的Defi生态系统，多重分红机制": "Innovative DeFi Ecosystem with Multiple Dividend Mechanisms",
	"NUT.介绍.代币信息": "Token Information",
	"NUT.介绍.代币名称": "Token Name",
	"NUT.介绍.NUT 代币": "NUT Token",
	"NUT.介绍.代币符号": "Token Symbol",
	"NUT.介绍.总供应量": "Total Supply",
	"NUT.介绍.一千万亿": "1 Quadrillion",
	"NUT.介绍.稳定比": "Stability Ratio",
	"NUT.介绍.美元兑日元": "USD/JPY",
	"NUT.介绍.奖励代币": "Reward Token",
	"NUT.介绍.三大资金池": "Three Major Fund Pools",
	"NUT.介绍.燃烧池": "Burn Pool",
	"NUT.介绍.NUT/ROON 交易对，持续燃烧通缩": "NUT/ROON trading pair, continuous burn deflation",
	"NUT.介绍.稳定池": "Stable Pool",
	"NUT.介绍.NUT/USDR 交易对，价格稳定支": "NUT/USDR trading pair, price stability support",
	"NUT.介绍.拖底池": "Support Pool",
	"NUT.介绍.ROON 转账即交易，X314协议，隐藏性拖底": "ROON transfer is trading, X314 protocol, hidden support",
	"NUT.介绍.交易手续费分配": "Transaction Fee Distribution",
	"NUT.介绍.回流底池燃烧": "Return to Support Pool Burn",
	"NUT.介绍.回流ROON LP池": "Return to ROON LP Pool",
	"NUT.介绍.价格拖底": "Price Support",
	"NUT.介绍.生态建设": "Ecosystem Construction",
	"NUT.介绍.持币分红": "Holding Dividends",
	"NUT.介绍.回购销毁": "Buyback and Destroy",
	"NUT.介绍.LP池机制": "LP Pool Mechanism",
	"NUT.介绍.LP每小时自动撤出0.25%": "LP automatically withdraws 0.25% per hour",
	"NUT.介绍.其中0.125%自动燃烧销毁": "0.125% automatically burned and destroyed",
	"NUT.介绍.另外0.125%分红给LP提供者": "Another 0.125% dividends to LP providers",
	"NUT.介绍.1%手续费实时分红给LP用户": "1% transaction fee real-time dividends to LP users",
	"NUT.介绍.参与质押机制": "Participate in Staking Mechanism",
	"NUT.介绍.向合约地址打入ROON代币100": "Transfer 100 ROON tokens to contract address",
	"NUT.介绍.ROON=1份，可多次参与": "ROON = 1 share, can participate multiple times",
	"NUT.介绍.全链上执行，透明可查": "Fully on-chain execution, transparent and verifiable",
	"NUT.介绍.收益分配": "Revenue Distribution",
	"NUT.介绍.35%全网分红ROON": "35% network-wide ROON dividends",
	"NUT.介绍.65%自动组LP锁定999年": "65% automatically form LP locked for 999 years",
	"NUT.介绍.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "Of 65 ROON: 32.5 buy NUT + 32.5 ROON form LP",
	"NUT.介绍.税收机制": "Tax Mechanism",
	"NUT.介绍.盈利税（20%）": "Profit Tax (20%)",
	"NUT.介绍.20%回购ROON分给参与者": "20% buyback ROON distributed to participants",
	"NUT.介绍.其中10%分红给LP用户": "Of which 10% dividends to LP users",
	"NUT.介绍.5%的利润将分给NFT资产持有者": "5% of profits distributed to NFT asset holders",
	"NUT.介绍.5%用于市值管理": "5% used for market value management",
	"NUT.介绍.砸盘税 (最高25%)": "Dump Tax (up to 25%)",
	"NUT.介绍.每天早上8点AVE价格为准": "Based on AVE price at 8 AM daily",
	"NUT.介绍.跌1%扣2%手续费": "Drop 1% deduct 2% transaction fee",
	"NUT.介绍.最高下跌12.5%时税率达25%": "Tax rate reaches 25% when dropping 12.5% maximum",
	"NUT.介绍.25% 回购ROON分给参与者": "25% buyback ROON distributed to participants",
	"NUT.介绍.持币分红": "Holding Dividends",
	"NUT.介绍.0.5%手续费用于持币分红ROON": "0.5% transaction fee used for ROON holding dividends",
	"NUT.介绍.单地址持币>100,000 NUT可参与": "Single address holding >100,000 NUT can participate",
	"NUT.介绍.前台手动领取，支付50% NUT价值": "Manual claim at frontend, pay 50% NUT value",
	"NUT.介绍.领取时50%销毁，50%到账": "50% burned, 50% to account when claimed",
	"NUT.介绍.NFT分红机制": "NFT Dividend Mechanism",
	"NUT.介绍.节点NFT(50%)": "Node NFT (50%)",
	"NUT.介绍.权重值分配分红": "Weighted value allocation dividends",
	"NUT.介绍.持币≥100.000 NUT激活": "Holding ≥100.000 NUT to activate",
	"NUT.介绍.白名单NFT(50%)": "Whitelist NFT (50%)",
	"NUT.介绍.加权平均分配分红": "Weighted average allocation dividends",
	"NUT.介绍.持币≥100.000 NUT激活": "Holding ≥100.000 NUT to activate",
	"NUT.介绍.重要提示": "Important Notice",
	"NUT.介绍.所有盈利税和砸盘税分红ROON": "All profit tax and dump tax dividends ROON",
	"NUT.介绍.领取时50%打入黑洞销毁，50%到用户钱包": "50% sent to black hole to burn, 50% to user wallet when claimed",
	"NUT.介绍.全链上执行，透明可查": "Fully on-chain execution, transparent and verifiable",
	"NUT.介绍.智能合约自动执行，无需人工干预": "Smart contract auto-execution, no manual intervention needed",

	"NUT.奖励池.资金池总览": "Fund Pool Overview",
	"NUT.奖励池.实时监控三大资金池运作状态": "Real-time monitoring of three major fund pools operation status",
	"NUT.奖励池.资金池总价值": "Total Fund Pool Value",
	"NUT.奖励池.24小时注入": "24h Inflow",
	"NUT.奖励池.24小时分配": "24h Distribution",
	"NUT.奖励池.24小时销毁": "24h Burn",
	"NUT.奖励池.LP池": "LP Pool",
	"NUT.奖励池.质押池": "Staking Pool",
	"NUT.奖励池.税收池": "Tax Pool",
	"NUT.奖励池.LP池流动性池": "LP Pool Liquidity Pool",
	"NUT.奖励池.运行中": "Running",
	"NUT.奖励池.交易手续费的35%注入LP池，增强流动性": "35% of transaction fees injected into LP pool, enhance liquidity",
	"NUT.奖励池.池子总价值": "Pool Total Value",
	"NUT.奖励池.今日注入": "Today's Inflow",
	"NUT.奖励池.累计分配": "Cumulative Distribution",
	"NUT.奖励池.累计注入": "Cumulative Inflow",
	"NUT.奖励池.查看详细数据": "View Detailed Data",
	"NUT.奖励池.操作记录": "Operation Records",
	"NUT.奖励池.查看全部": "View All",
	"NUT.奖励池.注入": "Inflow",
	"NUT.奖励池.加载更多": "Load More",

	"NUT.奖励池.LP流动性池": "LP Liquidity Pool",
	"NUT.奖励池.详细数据分析": "Detailed Data Analysis",
	"NUT.奖励池.概览": "Overview",
	"NUT.奖励池.图表": "Charts",
	"NUT.奖励池.记录": "Records",
	"NUT.奖励池.占比": "Proportion",
	"NUT.奖励池.数量": "Amount",
	"NUT.奖励池.LP代币": "LP Token",
	"NUT.奖励池.持有人数": "Holders Count",
	"NUT.奖励池.年华收益": "Annual Returns",
	"NUT.奖励池.日奖励": "Daily Rewards",
	"NUT.奖励池.7日资金流动趋势": "7-Day Fund Flow Trend",
	"NUT.奖励池.资金分配占比": "Fund Distribution Ratio",
	"NUT.奖励池.回购": "Buyback",
	"NUT.奖励池.销毁": "Burn",
	"NUT.奖励池.分配": "Distribution",

	"NUT.奖励池.质押奖励池": "Staking Reward Pool",
	"NUT.奖励池.交易手续费的25%用于质押奖励分配": "25% of transaction fees used for staking reward distribution",
	"NUT.奖励池.总质押量": "Total Staked Amount",
	"NUT.奖励池.质押人数": "Stakers Count",
	"NUT.奖励池.平均质押": "Average Staked",
	"NUT.奖励池.待领奖励": "Pending Rewards",
	"NUT.奖励池.待领奖励": "Pending Rewards",

	"NUT.奖励池.税收回购池": "Tax Buyback Pool",
	"NUT.奖励池.交易手续费的40%用于税收回购和销毁": "40% of transaction fees used for tax buyback and burn",
	"NUT.奖励池.今日回购": "Today's Buyback",
	"NUT.奖励池.累计销毁": "Cumulative Burn",
	"NUT.奖励池.盈利税": "Profit Tax",
	"NUT.奖励池.砸盘税": "Dump Tax",
	"NUT.奖励池.回购总额": "Total Buyback",
	"NUT.奖励池.销毁总额": "Total Burn",
	"NUT.奖励池.分配总额": "Total Distribution",
	"NUT.奖励池.日回购": "Daily Buyback",

	"弹窗.复制成功": "Copied successfully",
	"弹窗.复制失败": "Copy failed",
	"弹窗.确认": "Confirm",
	"弹窗.取消": "Cancel",
	"弹窗.上级邀请码": "Sponsor invitation code",
	"弹窗.知道了": "Got it",
	"弹窗.请输入邀请码": "Please enter invitation code",

	"吐司.敬请期待": "Coming soon",
	"吐司.操作成功": "Operation succeeded",
	"吐司.操作失败": "Operation failed",
	"吐司.请在钱包中打包": "Please confirm in your wallet",
	"吐司.暂未开放": "Not yet open",
	"吐司.用户拒绝提供程序访问": "User denied application access",
	"吐司.请刷新重试": "Please refresh and retry",
	"吐司.请输入邀请码": "Please enter invitation code",
	"吐司.操作成功请稍后刷新查看": "Operation successful, please refresh later to view",
	"吐司.添加流动性成功": "Liquidity added successfully",
	"吐司.余额不足": "Insufficient balance",
	"吐司.收款地址无效": "Invalid recipient address",

	"解押NFT": "Unstake NFT",
	"质押NFT": "Stake NFT",
	"选择NFT解押": "NFT to Unstake",
	"选择NFT质押": "NFT to Stake",
	"当前节点等级:黄金": "Node Level: ",
	"jiemiao": "Only Level 3 NFTs unstaked",
	"zhimiao": "Only Level 3 NFTs staked",
	"已选择": "Selected",
	"黄金": "Gold",
	"解押": "Unstake",
	"质押": "Stake",
	"个": "Piece",

	"添加流动性": "Add Liquidity",
	"交换代币": "Swap Tokens",
	"从": "From",
	"余额": "Balance",
	"请输入": "Please Enter",
	"至": "To",
	"池股份": "Pool Shares",
	"当前年利率": "Current Interest Rate",
	"代币": "Token",
	"美元稳定币": "Ethereum Stablecoin",
	"热门池": "Popular Pools",
	"兑换美元稳定币兑换": "Exchange USD Stablecoin",
	"以太坊": "Ethereum (ETH)",
	"亿美元": "100 Million USD",
	"四月": "April",
	"我的流动池": "My Liquidity Pools",
	"总计": "Total",
	"我的稳定币": "My Stablecoins",
	"小时交易量": "Hourly Trading Volume",
	"百万": "Million",
	"移除": "Remove",
	"添加更多": "Add More",
	"总薪酬": "Total Compensation",
	"池": "Pool",
	"交易池": "Trading Pool",
	"领取所有奖励": "Claim All Rewards",
	"移除流动性": "Remove Liquidity",
	"确定要移除": "Are Remove Liquidity",
	"我的流动性": "My Liquidity",
	"预计收益": "Estimated Earnings",
	"取消": "Cancel",
	"确认移除": "Confirm Removal",
	"跨链桥": "Cross-Chain Bridge",
	"预计到账时间": "Estimated Arrival Time",
	"分钟到账": "Arrives in Minutes",
	"安全级别": "Security Level",
	"高": "High",
	"手续费": "Fee",
	"美元": "US Dollar",
	"多边形": "Polygon",
	"代币数量": "Token Quantity",
	"": "USD Stablecoin",
	"接收地址": "Receiving Address",
	"分钟": "Minute(s)",
	"桥接手续费": "Bridge Fee",
	"目标链手续费": "Destination Chain Fee",
	"总手续费": "Total Fees",
	"开始跨链": "Start Cross-Chain",
	"最近跨链记录": "Recent Cross-Chain Records",
	"分钟前": "Minutes Ago",
	"待处理": "Pending",
	"完成": "Completed",
	"支持的网络": "Supported Networks",
	"企业绩效管理": "Enterprise Performance Management",
	"选择币种": "Select Currency",
	"滑点容差": "Slippage Tolerance",
	"费率": "Rate",
	"滑动": "Slide",
	"百分比": "Percentage",
	"网络费用": "Network Fee",
	"最近的交换": "Recent Swaps",

	"我的池": "My Liquidity Pool",
	'使用我的地址':'Use My Address',
    "我的LP.暂无数据": "No Data",
    "我的LP.复投": "Reinvest",
  }
